import { useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { baueHallOfFameEintrag, ladeSaisonRanking, sortiereRanking } from '../../utils/hallOfFame';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';

// Hall of Fame: Endstand einer Saison laden, bei Bedarf Punkte korrigieren,
// dann hallOfFame/{saison-id} schreiben (Format unverändert: saison,
// top3Plaetze, alleRaenge, teilnehmerAnzahl, abgeschlossenAm, erstelltVon).

const MEDAILLE = { 1: '🥇', 2: '🥈', 3: '🥉' };

function HallOfFameVerwaltung({ saisonId, saisonName, zeigeToast }) {
  const { userProfile } = useAuth();
  const [ranking, setRanking] = useState(null);
  const [laeuft, setLaeuft] = useState(null);
  const [bestaetigen, setBestaetigen] = useState(false);
  const [vorhanden, setVorhanden] = useState(null);

  const laden = async () => {
    setLaeuft('laden');
    setRanking(null);
    try {
      const [daten, hofSnap] = await Promise.all([
        ladeSaisonRanking(saisonId),
        getDoc(doc(db, 'hallOfFame', saisonId))
      ]);
      setVorhanden(hofSnap.exists() ? hofSnap.data() : null);
      setRanking(daten);
      if (daten.length === 0) zeigeToast('Keine Punkte für diese Saison', true);
    } catch (error) {
      zeigeToast('Fehler: ' + error.message, true);
    } finally {
      setLaeuft(null);
    }
  };

  const sortiere = sortiereRanking;

  const punkteAendern = (userId, wert) => {
    setRanking(r => sortiere(r.map(u => (u.userId === userId ? { ...u, punkte: parseFloat(wert) || 0 } : u))));
  };

  const speichern = async () => {
    setBestaetigen(false);
    setLaeuft('speichern');
    try {
      await setDoc(doc(db, 'hallOfFame', saisonId), baueHallOfFameEintrag(ranking, saisonName, userProfile?.displayName));
      setVorhanden({ abgeschlossenAm: new Date().toISOString() });
      zeigeToast(`Hall of Fame ${saisonName} gespeichert`);
    } catch (error) {
      zeigeToast('Fehler: ' + error.message, true);
    } finally {
      setLaeuft(null);
    }
  };

  return (
    <>
      <div className="karte">
        <h2>🏛️ Saison {saisonName} in die Hall of Fame</h2>
        <p className="karte__hinweis">
          Lädt den Endstand aus den Punkte-Docs. Punkte lassen sich vor dem Speichern korrigieren. Speichern überschreibt einen
          vorhandenen Eintrag dieser Saison.
        </p>
        <div className="aktion-zeile">
          <button type="button" className="aktion" onClick={laden} disabled={laeuft !== null}>
            {laeuft === 'laden' ? '⏳ Lade…' : '📊 Endstand laden'}
          </button>
          {vorhanden && <span className="status-chip status-chip--warn">Eintrag vorhanden{vorhanden.abgeschlossenAm ? ` (${new Date(vorhanden.abgeschlossenAm).toLocaleDateString('de-DE')})` : ''}</span>}
        </div>
      </div>

      {ranking && ranking.length > 0 && (
        <div className="karte">
          <h2>📊 Endstand ({ranking.length} Teilnehmer)</h2>
          <table className="rang-tabelle">
            <thead>
              <tr>
                <th className="spalte-rang">#</th>
                <th>Spieler</th>
                <th className="spalte-zahl spalte-nebenwert">Spiele</th>
                <th className="spalte-zahl spalte-nebenwert">Bonus</th>
                <th className="spalte-zahl">Punkte</th>
              </tr>
            </thead>
            <tbody>
              {ranking.map(u => (
                <tr key={u.userId}>
                  <td className="spalte-rang">{MEDAILLE[u.platz] || u.platz}</td>
                  <td>{u.username}</td>
                  <td className="spalte-zahl spalte-nebenwert">{u.gesamtSpiele.toFixed(1)}</td>
                  <td className="spalte-zahl spalte-nebenwert">{u.gesamtBonus.toFixed(1)}</td>
                  <td className="spalte-zahl">
                    <input type="number" className="hof-eingabe" value={u.punkte} step={0.1} onChange={e => punkteAendern(u.userId, e.target.value)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="aktion-zeile">
            {bestaetigen ? (
              <span className="bestaetigen">
                Hall of Fame {saisonName} {vorhanden ? 'überschreiben' : 'anlegen'}?
                <button type="button" className="aktion" onClick={speichern}>Ja</button>
                <button type="button" className="aktion aktion--neutral" onClick={() => setBestaetigen(false)}>Nein</button>
              </span>
            ) : (
              <button type="button" className="aktion" onClick={() => setBestaetigen(true)} disabled={laeuft !== null}>
                {laeuft === 'speichern' ? '⏳ Speichere…' : '💾 In Hall of Fame speichern'}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default HallOfFameVerwaltung;
